import { animate, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'jquery-slimscroll';
import MetisMenu from 'metismenujs';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { PermissionAclService } from 'src/app/shared/services/permission-acl.service';
import { environment } from 'src/environments/environment';
import { MenuItem } from '../models/navigation.model';
import { inArray } from 'jquery';
import { AuthService } from 'src/app/shared/services/auth.service';

declare var jQuery: any;

@Component({
  selector: 'app-navigation',
  templateUrl: 'navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, AfterViewInit, OnDestroy {
  mm: MetisMenu;
  serverUrl: string;
  hasAclAdmin: boolean;
  loadAllPermissions: boolean = false;
  p: any;
  modulesMenu: any = [];
  modulesPermissions: any = [];
  menuView: boolean = false;
  width = document.querySelector('body').offsetWidth;
  entidade:number|null = null;

  items: MenuItem[] = [];
  items_old: MenuItem[] = [
    { id: '', nome: 'Projetos', icone: 'layers', permissao: 'projetos',menu_navegacao_filhos: [
        { id: '', nome: 'Consulta Geral', icone: 'signal_cellular_alt', permissao: 'consulta_geral', menu_navegacao_filhos: [
            { id: 'projetos/projeto', nome: 'Projetos', icone: '', permissao: 'consulta_geral' },
            { id: 'projetos/estrategico', nome: 'Projetos Estratégicos', icone: '', permissao: 'consulta_geral' },
            //{ id: 'projetos/captacao', nome: 'Projetos em Captação', icone: '', permissao: 'consulta_geral' },
            { id: 'projetos/banco', nome: 'Banco de Projetos', icone: '', permissao: 'consulta_geral' },
            { id: 'projetos/ideacao', nome: 'Ideação de Projetos', icone: '', permissao: 'consulta_geral' },
            { id: 'projetos/favoritos', nome: 'Projetos Favoritados', icone: '', permissao: 'consulta_geral' },
            { id: 'projetos_old/agregador', nome: 'Projetos Agregadores', icone: '', permissao: 'consulta_geral' },
            { id: 'projetos_old/programa', nome: 'Programas', icone: '', permissao: 'consulta_geral' }
          ]
        },
        { id: '', nome: 'Consulta Geral Antigo', icone: 'signal_cellular_alt', permissao: 'consulta_geral', menu_navegacao_filhos: [
            { id: 'projetos_old/projeto', nome: 'Projetos', icone: '', permissao: 'consulta_geral' },
            { id: 'projetos_old/agregador', nome: 'Projetos Agregadores', icone: '', permissao: 'consulta_geral' },
            { id: 'projetos_old/programa', nome: 'Programas', icone: '', permissao: 'consulta_geral' }
          ]
        },
        { id: 'projetos/minhas-responsabilidades', nome: 'Minhas Responsabilidades', icone: 'inbox', permissao: 'consulta_geral' },
        { id: 'projetos/mapa', nome: 'Mapa Estratégico', icone: 'map', permissao: 'consulta_geral'},
        { id: '', nome: 'Relatórios', icone: 'docs', permissao: 'export', menu_navegacao_filhos: [
            { id: 'projetos/exportar', nome: 'Exportar', icone: '', permissao: 'export' },
            { id: 'projetos/exportar-dropbox', nome: 'Exportar - Dropbox', icone: '', permissao: 'export' },
            { id: 'projetos/importar', nome: 'Importar', icone: '', permissao: 'export' }
          ]
        },
        { id: 'projetos/demandas-monitoramento', nome: 'Demandas de Monitoramento', icone: 'assignment', permissao: 'demanda_monitoramento' }, 
        { id: '', nome: 'Admin SPGG', icone: 'admin_panel_settings', permissao: 'spgg_admin', menu_navegacao_filhos: [
            { id: '', nome: 'Status', icone: '', permissao: 'spgg_admin', menu_navegacao_filhos: [
              { id: 'projetos/admin-spgg/geral', nome: 'Sinaleiras', icone: '', permissao: 'spgg_admin' },
              { id: 'projetos/admin-spgg/status-operacionais', nome: 'Operacionais', icone: '', permissao: 'spgg_admin' },
            ]},
            { id: 'projetos/admin-spgg/bi-tematica', nome: 'Temática Indicador', icone: '', permissao: 'spgg_admin' },
            { id: 'projetos/admin-spgg/pontos-criticos-tipos', nome: 'Tipos Pontos Críticos', icone: '', permissao: 'spgg_admin' },
            { id: '', nome: 'SGO', icone: '', permissao: 'spgg_admin', menu_navegacao_filhos: [
              { id: 'projetos/admin-spgg/sgo-modulos', nome: 'Módulos', icone: '', permissao: 'spgg_admin' },
              { id: 'projetos/admin-spgg/sgo-situacoes-demanda', nome: 'Situações de demanda', icone: '', permissao: 'spgg_admin' },
            ]},
            { id: 'projetos/admin-spgg/orgao-setorialista', nome: 'Setorialista Captação', icone: '', permissao: 'spgg_admin' }
          ]
        }
      ]
    },
    { id: 'dashboard', nome: 'Dashboard', icone: 'space_dashboard', permissao: 'consulta_geral' },
    { id: '', nome: 'QR Obras', icone: 'qr_code', permissao: 'qr_obras', menu_navegacao_filhos: [
        { id: 'qrobras/pesquisa-geral', nome: 'Obras', icone: 'signal_cellular_alt', permissao: 'qr_obras_obras' },
        { id: 'qrobras-mapa', nome: 'Mapa', icone: 'map', permissao: '' },
        { id: '', nome: 'Admin', icone: 'admin_panel_settings', permissao: 'qr_obras_admin', menu_navegacao_filhos: [
            { id: 'qrobras/status', nome: 'Status', icone: '', permissao: 'qr_obras_admin' },
            { id: 'qrobras/geral', nome: 'Geral', icone: '', permissao: 'qr_obras_admin' },
            { id: 'qrobras/exporta', nome: 'Exportar', icone: '', permissao: 'qr_obras_admin' }
          ]
        }
      ]
    },
    { id: 'tutorial/user/pesquisa-geral', nome: 'Tutoriais', icone: 'developer_guide', permissao: 'tutoriais'},
    { id: '', nome: 'Reuniões', icone: 'group', permissao: 'reuniao', menu_navegacao_filhos:[
        { id: 'reuniao/reunioes', nome: 'Reuniões', icone: 'groups', permissao: 'reuniao'},
        { id: 'reuniao/admin', nome: 'Admin', icone: 'settings', permissao: 'reuniao_admin' }
      ]
    },
    { id: '', nome: 'Cadastro', icone: 'id_card', permissao: 'cadastro', menu_navegacao_filhos:[
        { id: 'cadastro/localizacao', nome: 'Localização', icone: 'map', permissao: '', menu_navegacao_filhos: [
            { id: 'cadastro/localizacao/municipios', nome: 'Municipios', icone: '', permissao: 'cadastro_municipios'},
            { id: 'cadastro/localizacao/coredes', nome: 'COREDEs', icone: '', permissao: 'cadastro_coredes'},
            { id: 'cadastro/localizacao/cre', nome: 'CRE', icone: '', permissao: 'cadastro_cre'},
            { id: 'cadastro/localizacao/crs', nome: 'CRS', icone: '', permissao: 'cadastro_crs'},
            { id: 'cadastro/localizacao/regioes-funcionais', nome: 'Regiões Funcionais', icone: '', permissao: 'cadastro_regioes_funcionais'},
        ]},
        { id: 'cadastro/usuarios', nome: 'Usuários', icone: 'user_attributes', permissao: '' , menu_navegacao_filhos: [
            { id: 'cadastro/usuarios/pessoas', nome: 'Usuário', icone: '', permissao: 'cadastro_usuario'},
            { id: 'cadastro/usuarios/papeis', nome: 'Papel', icone: '', permissao: 'cadastro_papel'},
            { id: 'cadastro/usuarios/diretoria', nome: 'Diretoria', icone: '', permissao: 'cadastro_diretoria'},
          ]
        },
        { id: 'cadastro/geral', nome: 'Geral', icone: 'manufacturing', permissao: '' , menu_navegacao_filhos: [
            { id: 'cadastro/geral/unidade-medida', nome: 'Unidades de medida', icone: '', permissao: 'cadastro_unidade_medida'},
            { id: 'cadastro/geral/orgao', nome: 'Órgão', icone: '', permissao: 'cadastro_orgao'},
            { id: 'cadastro/geral/objetivos-estrategicos', nome: 'Obj. Estratégico', icone: '', permissao: 'cadastro_objetivos_estrategicos'},
            { id: 'cadastro/geral/mapa-estrategico', nome: 'Mapa Estratégico', icone: '', permissao: 'cadastro_mapa_estrategico'},
            { id: 'cadastro/geral/exercicio', nome: 'Exercício', icone: '', permissao: 'cadastro_exercicio'},
            { id: 'cadastro/geral/modelo-modulos', nome: 'Modelo Módulos', icone: '', permissao: 'cadastro_modelo_modulos'},
            { id: 'cadastro/geral/modulo', nome: 'Módulo', icone: '', permissao: 'cadastro_modulo'},
            { id: 'cadastro/geral/projeto-campo', nome: 'Projeto Campos', icone: '', permissao: 'cadastro_projeto_campo'},
            { id: 'cadastro/geral/integracao', nome: 'Integração SEI', icone: '', permissao: 'cadastro_integracao'},
          ]
        },
        { id: 'cadastro/data-sistema', nome: 'Data do Sistema', icone: 'date_range', permissao: 'util' }
      ]
    },
    { id: '', nome: 'Operação', icone: 'folder_copy', permissao: 'operacao', menu_navegacao_filhos:[
        { id: 'operacao/fpe', nome: 'FPE', icone: 'account_balance', permissao: 'operacao' }
      ]
    },
    { id: '', nome: 'Pré-Projeto', icone: 'photo_frame', permissao: 'pre_projeto', menu_navegacao_filhos:[
        { id: 'pre-projeto/projeto', nome: 'Projetos', icone: 'signal_cellular_alt', permissao: 'pre_projeto_projetos' },
        { id: 'pre-projeto/processos', nome: 'Processos', icone: 'display_settings', permissao: 'pre_projeto_processos' },
        { id: '', nome: 'Admin', icone: 'manage_accounts', permissao: 'pre_projeto_admin', menu_navegacao_filhos: [
            { id: '', nome: 'Projeto', icone: '', permissao: 'pre_projeto_admin', menu_navegacao_filhos: [
              { id: 'pre-projeto/admin/projeto-situacao', nome: 'Situação', icone: '', permissao: 'pre_projeto_admin' },
              { id: 'pre-projeto/admin/projeto-fonte-recurso', nome: 'Fonte Recurso', icone: '', permissao: 'pre_projeto_admin' },
              { id: 'pre-projeto/admin/projeto-moeda', nome: 'Moeda', icone: '', permissao: 'pre_projeto_admin' },
            ] },
            { id: '', nome: 'Produto', icone: '', permissao: 'pre_projeto_admin', menu_navegacao_filhos: [
              { id: 'pre-projeto/admin/produto-etapa-modalidade', nome: 'Etapa da Modalidade', icone: '', permissao: 'pre_projeto_admin' },
              { id: 'pre-projeto/admin/produto-documento', nome: 'Documento', icone: '', permissao: 'pre_projeto_admin' },
              { id: 'pre-projeto/admin/produto-modalidade', nome: 'Modalidade', icone: '', permissao: 'pre_projeto_admin' },
            ] },
            { id: '', nome: 'Processo', icone: '', permissao: 'pre_projeto_admin', menu_navegacao_filhos: [
              { id: 'pre-projeto/admin/processo-questao', nome: 'Questão', icone: '', permissao: 'pre_projeto_admin' },
              { id: 'pre-projeto/admin/processo-status', nome: 'Status', icone: '', permissao: 'pre_projeto_admin' },
            ] },
            { id: '', nome: 'Link', icone: '', permissao: 'pre_projeto_admin', menu_navegacao_filhos: [
              { id: 'pre-projeto/admin/link-evidencia', nome: 'Link Evidência', icone: '', permissao: 'pre_projeto_admin' },
              { id: 'pre-projeto/admin/link-legislacao', nome: 'Link Legislação', icone: '', permissao: 'pre_projeto_admin' },
            ] },
            { id: '', nome: 'Equipe', icone: '', permissao: 'pre_projeto_admin', menu_navegacao_filhos: [
              { id: 'pre-projeto/admin/equipe-responsabilidade', nome: 'Responsabilidade', icone: '', permissao: 'pre_projeto_admin' },
            ] },
            { id: '', nome: 'Documento', icone: '', permissao: 'pre_projeto_admin', menu_navegacao_filhos: [
              { id: 'pre-projeto/admin/documento-tipo', nome: 'Tipo', icone: '', permissao: 'pre_projeto_admin' },
            ] },
            { id: 'pre-projeto/admin/exportacsv', nome: 'Exportar', icone: '', permissao: 'pre_projeto_admin' },
        ] }
      ]
    },
    { id: 'mapa-governo', nome: 'Mapa de Governo', icone: 'globe', permissao: 'mapa_governo', tipo_link: 'href' },
    { id: 'painel-governador/dashboard', nome: 'Painel Governo', icone: 'dashboard', permissao: 'painel_governador', tipo_link: 'href' }
  ];
  itemsLegacy: MenuItem[] = [
    {
      id: '',
      nome: 'Legado',
      icone: 'history',
      permissao: null,
      menu_navegacao_filhos: []
    }
  ];

  constructor(
    private router: Router,
    private permissionAcl: PermissionAclService,
    private authService: AuthService
  ) { }

  async ngOnInit(): Promise<void> {
    this.serverUrl = environment.serverUrl;
    this.entidade = await this.authService.getSession();
    this.getNavbar();
    if (this.width > 1445) {
      this.menuView = true;
    }

    EventSharedService.get('menuView').subscribe((res) => {
      this.menuView = !this.menuView;
    });
  }

  ngAfterViewInit() {
    this.getAllPermissions().then(
      (r) => {
        this.p = r.permissions;
        this.modulesMenu = r.modules_menu;
        this.setMenuLegacy();
        this.loadAllPermissions = true;
        if (r?.mgs_info)
          EventSharedService.get('mgsInfo').emit(r?.mgs_info);
        this.initMenu();
        if (jQuery('body').hasClass('fixed-sidebar')) { jQuery('.sidebar-collapse').slimscroll({   height: '100%', });
        }
      }
    );
  }
  
  initMenu() {
    setTimeout(() => {
      this.mm = new MetisMenu('#side-menu');
    });
  }

  menuChange() {
    if (this.width < 1445) {
      EventSharedService?.get('menuView')?.emit();
    }
  }

  ngOnDestroy() {
    this.mm?.dispose();
  }

  activeRoute(routenome: string): boolean {
    return this.router.url.indexOf(routenome) > -1;
  }


  getAllPermissions(): Promise<any> {
    return new Promise<boolean>((resolve, reject) => {
      this.permissionAcl.getAllPermissions().subscribe({
        next: (r) => { resolve(r);
        },
        error: (e) => { reject(console.log('e', e)) }
      })
    })
  }
  getNavbar(){
    this.permissionAcl.getNavbar().subscribe({
      next: (nav) => {
        this.items = nav;
      },
      error: (error) => {
        console.log(error)
      }
    } );
  }

  
  setMenuLegacy(){
    // console.log(this.itemsLegacy[0])
    if(this.modulesMenu?.length > 0){
      this.itemsLegacy[0].menu_navegacao_filhos = this.modulesMenu.map(module => ({
        id: module.url.replace('/', ''),
        nome: module.label,
        icone: module.icon.replace('.svg', ''),
        permissao: module.permission,
        external: true,
        url: module.url,
        tipo_link: 'href',
        menu_navegacao_filhos: []
      }));
    }
    else{
      this.itemsLegacy = [];
    }
  }

  
  hasPermission(key:string):boolean{
    if(!key) return true;
    let keys = key?.split('.') ?? [];
    let currentPermission = this.p;
    if(currentPermission){
      keys.forEach(k => {
        currentPermission = currentPermission[k];
      });
    }
    return currentPermission ?? false;
  }

  toggleItem(item: any): void {
    if (item.menu_navegacao_filhos?.length > 0) {
      item.open = !(item.open ?? false) ;
    } else {
      this.menuChange();
    }
  }

  getActiveRoute(item: MenuItem): boolean {
    let url = this.router.url.split('?')[0]
      .replace(/^\//, '')
      .replace('/admin/', '')
      .replace('/create', '')
      .replace('/view', '')
      .replace('/edit', '');

    const routes = this.routesChild(item);
    return routes.includes(url);
  }

  routesChild(item: MenuItem): string[] {
    const result: string[] = [];

    if (item.id) {
      result.push(item.id);
    }
    if (item.menu_navegacao_filhos?.length > 0) {
      for (const child of item.menu_navegacao_filhos) {
        result.push(...this.routesChild(child));
      }
    }

    return result;
  }

  buildLink(item: MenuItem): string[] | null {
    if (item?.menu_navegacao_filhos?.length > 0 || !item.id ||item.tipo_link != 'route') {
      return null;
    }
    return ['/', ...item.id.replace(/^\/+/, '').split('/')];
  }

  buildLinkHref(item: MenuItem): string {
    if (item.menu_navegacao_filhos?.length > 0 || !item.id || item.tipo_link != 'href') {
      return '#';
    }
    if (item.id.includes('mapa-governo')) {
      return '//mapa-governo.' + window.location.hostname;
    }
    if (item.id.includes('painel-governador')) {
      return '//painel-governador.' + window.location.hostname;
    }
    if (item.id.includes('qrobras-mapa')) {
      return '//obras.' + window.location.hostname + '/' + this.entidade;
    }

    return this.serverUrl + '/' + item.id;
  }


}
